import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import {
  KITCHEN_CLOSED_DIALOG_BODY,
  KITCHEN_CLOSED_DIALOG_TITLE,
} from '../../utils/storeStatus';
import './KitchenClosedDialog.css';

export default function KitchenClosedDialog({ open, onClose, onProceed }) {
  if (!open) return null;

  return (
    <div className="kitchen-closed-overlay" role="presentation" onClick={onClose}>
      <div
        className="kitchen-closed-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="kitchen-closed-title"
        aria-describedby="kitchen-closed-desc"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="kitchen-closed-title" className="kitchen-closed-dialog__title">
          <FaInfoCircle aria-hidden />
          {KITCHEN_CLOSED_DIALOG_TITLE}
        </h2>
        <p id="kitchen-closed-desc" className="kitchen-closed-dialog__body">
          {KITCHEN_CLOSED_DIALOG_BODY}
        </p>
        <div className="kitchen-closed-dialog__actions">
          <button
            type="button"
            className="kitchen-closed-dialog__btn kitchen-closed-dialog__btn--secondary"
            onClick={onClose}
          >
            Close
          </button>
          <button
            type="button"
            className="kitchen-closed-dialog__btn kitchen-closed-dialog__btn--primary"
            onClick={onProceed}
          >
            Yes, Proceed
          </button>
        </div>
      </div>
    </div>
  );
}
